import React, { FC } from 'react'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

interface Props {
  children: string | React.ReactNode
  title: string
  isOpen: boolean
  onClose: any
}

const GenericModal: FC<Props> = ({
  children,
  title,
  isOpen,
  onClose
}) => (
  <Modal
    onClose={onClose}
    isOpen={isOpen}
    size={{ base: 'full', md: 'xl' }}
    isCentered
    closeOnOverlayClick={true}
    scrollBehavior="inside"
  >
    <ModalOverlay />
    <ModalContent
      backgroundColor="baseNeutral.100"
      minWidth={{ base: null, md: '890px' }}
      borderRadius={{ base: '0', sm: '10px' }}
      px={{ base: 'xl', md: 'xxl' }}
    >
      {title &&
        <ModalHeader
          borderBottom="1px solid #dadde1"
          fontFamily="Montserrat-SemiBold"
          px="0"
        >
          {title}
        </ModalHeader>
      }
      <ModalCloseButton mt="1" />
      <ModalBody m="0" px="0" pb="xl" pt="0">
        {typeof children === 'string' ?
          <Text
            as="div"
            fontFamily="Montserrat-Regular"
            color="baseDark"
            className="landing-text"
            dangerouslySetInnerHTML={{
              __html: children,
            }}
          />
          :
          <Text fontFamily="Montserrat-Regular" color="baseDark">
            {children}
          </Text>
        }
      </ModalBody>
    </ModalContent>
  </Modal>
)

export default GenericModal
